// extracted by mini-css-extract-plugin
export default {"main_div":"PatientModal_main_div__Ic1Nn","error_msg":"PatientModal_error_msg__1sa3g"};